import { render, staticRenderFns } from "./TransformerDetail.vue?vue&type=template&id=45be4824&scoped=true"
import script from "./TransformerDetail.vue?vue&type=script&lang=ts"
export * from "./TransformerDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45be4824",
  null
  
)

export default component.exports